import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { initI18n } from "@envirohub/i18n";
import { createQueryClient } from "@envirohub/utils";
import "@envirohub/ui/src/styles/globals.css";
import { ThemeProvider, Toaster, TooltipProvider } from "@envirohub/ui";
import App from "./App";

const chunkReloadKey = "envirohub:customer:chunk-reload";

window.addEventListener("vite:preloadError", (event) => {
  const lastReload = Number(window.sessionStorage.getItem(chunkReloadKey) ?? 0);
  if (Date.now() - lastReload < 60_000) return;

  event.preventDefault();
  window.sessionStorage.setItem(chunkReloadKey, String(Date.now()));
  window.location.reload();
});

// Initialise internationalisation (default: English)
initI18n("en");
console.log("[envirohub] deploy marker: docker-musl-fix 2026-09-27");

// QueryClient with global API error handling (normalizes + toasts failures).
const queryClient = createQueryClient();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={300}>
            <App />
            <Toaster />
          </TooltipProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
